import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {Button, Grid, GridColumn, Modal, ModalCloser, ModalContent, ModalFooter, ModalHeader} from '../../../patterns';

export const SendResultsHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).teamResultsStore;

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('dashboard.send-results-modal.header')}</h4>
            </ModalHeader>
            <ModalContent>
                <Grid>
                    <GridColumn>
                        <h4>{store.label('dashboard.send-results-modal.content')}</h4>
                        <br/>
                    </GridColumn>
                </Grid>
                <ModalCloser>
                    <Button block={true} color="white" text={store.label('send-results.submit')}
                        onClick={(): Promise<void> => store.sendResultsLink()}
                        className={'button button--block button--color-green-border'}/>
                </ModalCloser>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('send-results.quit')} className={'button button--block button--color-red-border'}/>
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
